import { useMutation, useQueryClient } from '@tanstack/react-query';
import { markAsRead, resourcesQueryKey } from '@fe-learner-common';
import { useConfigContext } from '@fe-core/context';

export const useMarkResourceAsRead = ({
  participationId,
  resourceId,
}: {
  participationId: string;
  resourceId: string;
}) => {
  const { config } = useConfigContext();

  if (!config?.apiUrls?.aleweb) {
    throw new Error('useUnlockAllActivities - Missing API URL for aleweb');
  }

  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => {
      return markAsRead({
        baseUrl: config?.apiUrls?.aleweb as string,
        participationId,
        resourceId,
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: resourcesQueryKey(participationId),
      });
    },
    onError: (error) => {
      console.error('Error marking resource as read', error);
    },
  });
};
